import { supabase } from '../lib/supabase';

/**
 * Send contact form email via Edge Function
 * @param {Object} contactData - Contact form data
 * @param {string} contactData.subject - Email subject
 * @param {string} contactData.message - Email message
 * @param {string} contactData.userEmail - User's email address
 * @returns {Promise<Object>} Response from Edge Function
 */
export const sendContactEmail = async ({ subject, message, userEmail }) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('send-contact-email', {
      body: {
        subject,
        message,
        userEmail
      }
    });

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error sending contact email:', error);
    throw error;
  }
};